export const INCORRECT_PASSWORD = 'Пароль не соответствует требованиям';
export const INCORRECT_EMAIL = 'Некорректный email';
